<app-annex-summary [agreement]="agreement" [dataForAnnex]="dataForAnnex" [annexData]="annexData" [mode]="mode"> </app-annex-summary>
